import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { api, fmtPrice } from "../lib/api";
import { useCart } from "../context/CartContext";
import { getRecentlyViewed } from "../lib/recentlyViewed";
import { handleImgError } from "../lib/imgFallback";
import { toast } from "sonner";

export default function RecommendationRail({ title = "You May Also Like" }) {
  const { items, addItem } = useCart();
  const [recs, setRecs] = useState(null);

  useEffect(() => {
    const cart_slugs = items.map((i) => i.slug);
    const viewed_slugs = getRecentlyViewed().map((p) => p.slug);
    api.post("/recommendations", { cart_slugs, viewed_slugs })
      .then(({ data }) => setRecs(data.recommendations || []))
      .catch(() => setRecs([]));
  }, []);

  if (recs !== null && recs.length === 0) return null;

  return (
    <section data-testid="recommendation-rail" className="mx-auto max-w-[1500px] px-6 sm:px-10 py-16">
      <div className="flex items-center gap-2 mb-8">
        <Sparkles className="h-4 w-4 text-[#4ADE80]" />
        <h2 className="font-display text-2xl tracking-tight text-[#F5F5F5]">{title}</h2>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {(recs || Array.from({ length: 4 })).map((p, i) =>
          p ? (
            <motion.div key={p.slug} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
              data-testid={`rec-${p.slug}`} className="group bg-[#1F1F1F] border border-white/[0.06] hover:border-[#4ADE80]/40 transition-colors">
              <Link to={`/products/${p.slug}`}>
                <div className="aspect-square overflow-hidden bg-[#0F0F10]">
                  <img src={p.image} alt={p.name} loading="lazy" onError={handleImgError} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
              </Link>
              <div className="p-5">
                <Link to={`/products/${p.slug}`}><h3 className="font-display text-[15px] text-[#F5F5F5] group-hover:text-[#4ADE80] transition-colors">{p.name}</h3></Link>
                {p.reason && <p className="mt-1 text-[11px] text-[#4ADE80] italic">{p.reason}</p>}
                <div className="mt-3 flex items-center justify-between">
                  <span className="font-display text-sm">{fmtPrice(p.price)}</span>
                  <button data-testid={`rec-add-${p.slug}`} onClick={() => { addItem(p, 1); toast.success(`${p.name} added`); }}
                    className="btn-press text-[10px] uppercase tracking-[0.16em] text-[#0F0F10] bg-[#4ADE80] px-3 py-1.5 hover:bg-[#6FE998]">Add</button>
                </div>
              </div>
            </motion.div>
          ) : (
            <div key={i} className="skeleton aspect-[3/4]" />
          )
        )}
      </div>
    </section>
  );
}
